import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/lib/auth';
import { toast } from 'sonner';

export default function Login() {
    const { loginCustomer } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const [email, setEmail] = useState('priya@example.com');
    const [password, setPassword] = useState('demo123');
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            await loginCustomer(email, password);
            toast.success('Welcome back to Inorbit One');
            const next = new URLSearchParams(location.search).get('next') || '/loyalty';
            navigate(next);
        } catch (err) {
            toast.error(err?.response?.data?.detail || 'Invalid credentials');
        } finally { setBusy(false); }
    };

    return (
        <div className="min-h-screen grid md:grid-cols-2" data-testid="login-page">
            <div className="hidden md:block relative">
                <img src="https://static.wixstatic.com/media/9bdc47_0526f20fdf6f432bb55f4d3733c41628~mv2.png" alt="" className="absolute inset-0 w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-black/20" />
                <div className="absolute bottom-16 left-16 right-16 text-white">
                    <div className="overline text-gold mb-6">Inorbit One</div>
                    <div className="font-serif text-5xl leading-tight">Welcome back to your<br /><span className="italic text-gold">premium shopping life.</span></div>
                </div>
            </div>
            <div className="flex items-center justify-center px-6 md:px-16 py-16 bg-ivory">
                <form onSubmit={submit} className="w-full max-w-md">
                    <Link to="/" className="overline text-gold">INORBIT ONE</Link>
                    <h1 className="font-serif text-5xl text-navy mt-6 mb-12 leading-tight">Sign in</h1>
                    <div className="space-y-6">
                        <div>
                            <label className="overline">Email</label>
                            <input className="input-luxury" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email-input" type="email" />
                        </div>
                        <div>
                            <label className="overline">Password</label>
                            <input className="input-luxury" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password-input" />
                        </div>
                    </div>
                    <button type="submit" disabled={busy} className="btn-primary mt-12 w-full justify-center" data-testid="login-submit-btn">
                        {busy ? 'Signing in…' : 'Sign In'}
                    </button>
                    <div className="mt-8 text-sm text-text-secondary text-center">
                        New to Inorbit One?{' '}
                        <Link to="/register" className="text-navy font-medium underline" data-testid="login-to-register">Create account</Link>
                    </div>
                    <div className="mt-12 pt-8 border-t border-border-subtle text-xs text-text-tertiary text-center">
                        <div className="overline mb-2 text-text-tertiary">Demo Account</div>
                        priya@example.com / demo123
                    </div>
                </form>
            </div>
        </div>
    );
}
